import React from 'react';
import PropTypes from 'prop-types';

import {
  Picker,
  StyleSheet,
  TextInput,
  Text,
  Platform,
  ActionSheetIOS,
  TouchableOpacity,
} from 'react-native';
import langmap from 'langmap';

class LanguagePicker extends React.Component { // eslint-disable-line react/prefer-stateless-function
  static getDerivedStateFromProps(props, state) {
    if (!state.dirty && props.value !== state.value) {
      return {
        value: props.value,
      };
    }
    return {};
  }

  constructor(props, context) {
    super(props, context);

    this.showActionSheet = this.showActionSheet.bind(this);

    const { value } = this.props;

    this.state = {
      dirty: false,
      value,
      allLangs: Object.keys(langmap).sort((a, b) => langmap[a].englishName > langmap[b].englishName).filter((lang) => (
        lang.indexOf('-') === -1 && lang.indexOf('_') === -1
      )),
    };
  }

  showActionSheet = () => {
    const { allLangs } = this.state;
    const { onChange } = this.props;

    ActionSheetIOS.showActionSheetWithOptions(
      {
        options: ['Cancel', ...allLangs.map((lang) => `${langmap[lang].englishName} - ${langmap[lang].nativeName}`)],
        cancelButtonIndex: 0,
        tintColor: 'green',
      },
      (buttonIndex) => {
        console.log('clicked');
        console.log(buttonIndex);
        console.log(allLangs[buttonIndex - 1]);
        if (buttonIndex > 0) {
          this.setState({
            dirty: true,
            value: allLangs[buttonIndex - 1],
          });
          onChange(allLangs[buttonIndex - 1]);
        }
      }
    );
  };

  render() {
    const {
      style, onBlur, onChange,
    } = this.props;
    const {
      allLangs, value,
    } = this.state;

    // console.log('LanguagePicker');
    // console.log(value);
    // console.log(langmap[value]);

    if (Platform.OS === 'ios') {
      return (
        <TouchableOpacity
          style={{
            flex: 1,
            alignItems: 'flex-start',
            justifyContent: 'center',
            minHeight: style.minHeight,
            height: style.minHeight,
          }}
          onPress={this.showActionSheet}
        >
          <Text
            style={{
              fontSize: style.fontSize,
            }}
          >
            {value ? `${langmap[value].englishName} - ${langmap[value].nativeName}` : ''}
          </Text>
        </TouchableOpacity>
      );
    }

    const styleItem = StyleSheet.create({
      fontSize: style.fontSize,
      minHeight: style.minHeight,
      height: style.minHeight,
      // fontColor: 'red'
      paddingVertical: 8,
    });

    const stylePicker = {
      borderWidth: 0,
      backgroundColor: 'transparent',
      padding: 15,
    };
    if (Platform.OS === 'web') {
      stylePicker['-webkit-appearance'] = 'none';
    }

    return (
      <Picker
        mode="dialog" // TODO(clairbee): Android only???
        onBlur={onBlur}
        onValueChange={onChange}
        selectedValue={value}
        itemStyle={styleItem}
        style={stylePicker}
      >
        {allLangs.map((lang) => (
          <Picker.Item key={lang} label={`${langmap[lang].englishName} - ${langmap[lang].nativeName}`} value={lang} />
        ))}
      </Picker>
    );
  }
}

LanguagePicker.defaultProps = {
  value: 'en',
  style: () => undefined,
};

LanguagePicker.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object, // TextInput.propTypes.style,
  value: PropTypes.string,
};

export default LanguagePicker;
